export type Guid = string;
export const EMPTY_GUID: Guid = "00000000-0000-0000-0000-000000000000";
const guidPattern = /^[0-9a-f]{8}(-[0-9a-f]{4}){3}-[0-9a-f]{12}$/i;

class GuidHelperImpl
{
    get empty(): Guid { return EMPTY_GUID; }

    isGuid(value: unknown): value is Guid
    {
        return !!value
            && typeof value === "string"
            && guidPattern.test(value.toLowerCase());
    }

    isEmptyGuid(value: unknown): value is Guid
    {
        return this.isGuid(value)
            && value === EMPTY_GUID;
    }


    IsGoodGuid(value: unknown): value is Guid
    {
        return this.isGuid(value)
            && !this.isEmptyGuid(value);
    }

    newGuid(): Guid
    {
        return `${s4()}${s4()}-${s4()}-${s4()}-${s4()}-${s4()}${s4()}${s4()}`;

        function s4(): string
        {
            return Math.floor((1 + Math.random()) * 0x10000)
                .toString(16)
                .substring(1);
        }
    }
}

export const GuidHelper = new GuidHelperImpl();
